import { useMemo } from "react";
import localStorageKey from "../../../../enumerations/localStorageKey";
import { envChangeType } from "../../../../plugins/utils";
import { useGetGameV2 } from "../../hooks/home1bbet.hooks";
import styles from "./style.module.scss";

const CURRENCY = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);
const BRAND_IMAGE_GROUPS = [
  ["pp", "pplive", "onepp", "onepplive", "agppslot", "omgppslot"],
  ["pg", "onepg", "agpgslot", "omgpgslot"],
  ["welive", "welottery", "weblockchain", "wesport", "wefish", "weslot"],
  [
    "jili",
    "jilifish",
    "onejilislot",
    "onejilifish",
    "onejilicard",
    "onejilicasino",
    "agjilislot",
    "omgjilislot",
  ],
  ["jdbslot", "jdbfish", "onejdbslot", "onejdbfish", "agjdbslot", "omgjdbslot"],
  ["evo", "evoplay", "oneevolive"],
  ["saba", "onesaba"],
  ["aghsdslot", "onehacksaw", "omghacksaw"],
  ["fc", "agfcslot", "omgfcslot"],
  ["spribeone", "omgspribe"],
  ["oneredtigerslot", "omgredtiger"],
  ["agtadaslot", "omgtadaslot"],
  ["agcpslot", "omgcpslot"],
  ["agwgslot", "omgwgslot"],
];

const BRAND_IMAGE_ALIAS_MAP = BRAND_IMAGE_GROUPS.reduce((map, group) => {
  if (!group.length) return map;
  const canonicalCode = group[0];
  group.forEach((brandCode) => {
    map.set(brandCode, canonicalCode);
  });
  return map;
}, new Map());

const BrandList = () => {
  const { data: allGames } = useGetGameV2(
    {
      enabled: !!CURRENCY,
    },
    {
      excludedCategories: [],
    },
  );

  const brandList = useMemo(() => {
    const categories = allGames?.category_list || [];
    const flatBrands = categories
      .filter((category) => category?.game_category_code !== "hot")
      .flatMap((category) => category?.game_3th || [])
      .filter((brand) => brand?.game_3th_code && !brand.game_3th_code.startsWith("all."));

    const uniqueByCode = new Map();
    flatBrands.forEach((brand) => {
      const imageCode = BRAND_IMAGE_ALIAS_MAP.get(brand.game_3th_code) || brand.game_3th_code;
      if (!uniqueByCode.has(imageCode)) {
        uniqueByCode.set(imageCode, {
          ...brand,
          image_code: imageCode,
        });
      }
    });

    return Array.from(uniqueByCode.values());
  }, [allGames]);

  return (
    <div className={styles.brandListContainer}>
      {brandList.map((brand) => (
        <div key={brand.image_code} className={styles.brandItem}>
          <img
            className={styles.brandImage}
            src={`/images/platform/brand/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${brand.image_code}.png`}
            alt={brand.game_3th_name || brand.game_3th_code}
            loading="lazy"
          />
        </div>
      ))}
    </div>
  );
};

export default BrandList;
